
import React,{useState} from "react"

import { Button, FormControl, Grid, MenuItem, Select, TextField, Tooltip, Typography } from '@mui/material';

import { serviceProvider } from "../../provider/serviceProvider";
import {toast} from "react-toastify";

const ActivateUserModalBody = ({handleCloseActivateUserModal,userId,pageState,getUsersList}:any) => {

    const handleActivateUser=(userId :string)=>{
        const param =`${userId}/activate/true`
      serviceProvider.userService.put(param,{}).then((res)=>{
        console.log(res);
        if(res.responseCode ===200){
          toast.success(res.message)
          handleCloseActivateUserModal()
          // setTimeout(()=>{
          //   // window.location.reload();
          //   window.location.href =`/users-management?index=${indexNumber}`
          // },100)
          const query = `search?uId=NA&email=all&fullName=all&isActive=${false}&offset=${pageState.page}&limit=${pageState.pageSize}&order=recordUpdatedts.desc&profile=BASIC`
  getUsersList(query)
        }else{
          toast.error(res?.message || "Something Went Wrong!!")
        }
      }).catch((err)=>{
        console.log(err)
        toast.error(err?.data?.message || "Something Went Wrong!!")
        handleCloseActivateUserModal()
      })
      }
    
    return (
        <Grid container>
        <Grid item xs={12}>
          <Typography variant="h6" component="h6" textAlign="center">Confirm to Activate user?</Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container columnSpacing={2} className="btn-container">
            <Grid item xs={6} display="flex" justifyContent="flex-end">
              <Button variant="outlined" className="rounded-btn-outlined" onClick={handleCloseActivateUserModal}>Cancel</Button>
            </Grid>
            <Grid item xs={6}>
              <Button variant="contained" className="rounded-btn-fill" onClick={()=>handleActivateUser(userId)}>Confirm</Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };


  export default ActivateUserModalBody;